import { Intent, Tag } from "@blueprintjs/core"
import { CSSProperties } from "react"

/* Protopia Ecosystem component */
export interface IDiapazoneLabelProps {
    start_date: number
    finish_date: number
    className?: string
    style?: CSSProperties
    labelClassName?: string
    intent?: Intent
    round?: boolean
    minimal?: boolean
}
const PeriodLabel = (props: IDiapazoneLabelProps): JSX.Element => {
    const getDate = (): string => {
        let startDate: string = "", 
            finishDate: string = "",
            yearS: string = "", 
            yearF: string = ""
        const options: Intl.DateTimeFormatOptions = { 
            // year: 'numeric',
            month: 'long',
            day: 'numeric',
        } 
        const years: Intl.DateTimeFormatOptions = { 
            year: 'numeric',
        } 

        if(props.start_date) {
            const start     = Number(props.start_date!) * 1000
            const s: Date   = new Date( start )
            startDate       = s.toLocaleDateString( "ru-RU", options )
            yearS           = s.toLocaleDateString( "ru-RU", years )
        }     
        if(props.finish_date) {
            const finish    = Number(props.finish_date!) * 1000
            const f: Date   = new Date( finish )
            finishDate      = f.toLocaleDateString( "ru-RU", options )
            yearF            = f.toLocaleDateString( "ru-RU", years )
        } 
        const delimiter: string = props.finish_date && props.start_date
            ?
            " - "
            : ""
        if( yearS === yearF ) {
            return startDate + delimiter + finishDate + " " + yearF
        }
        else {
            return startDate + " " + yearS + delimiter + finishDate + " " + yearF
        }
    } 
    return <Tag 
        round={props.round} 
        minimal={props.minimal} 
        className={props.className} 
        style={props.style} 
        intent={ props.intent } 
        role="article" 
    >
        <span className={props.labelClassName}>{ getDate() }</span>
    </Tag> 
}
export default PeriodLabel